import { ColumnType } from "antd/es/table";
import { useTranslation } from "react-i18next";
import { Table } from "../../../components/Table/Table";
import { IzvestajiOPrometuProizvodnja } from "../../../modules/trackAndTrace/trackAndTrace.types";

const ProizvodnjaTable = ({
  proizvodnja,
}: {
  proizvodnja: IzvestajiOPrometuProizvodnja[];
}) => {
  const { t } = useTranslation();

  const columns = [
    {
      title: t("TRACK.NAZIV_PRIVREDNOG_SUBJEKTA"),
      dataIndex: "nazivDrustva",
      key: "nazivDrustva",
      width: 250,
    },
    {
      title: t("TRACK.PIB"),
      dataIndex: "pib",
      key: "pib",
      width: 150,
    },
    {
      title: t("TRACK.PRIMLJENO"),
      dataIndex: "primljeno",
      key: "primljeno",
      width: 150,
    },
    {
      title: t("TRACK.POSLATO"),
      dataIndex: "poslato",
      key: "poslato",
      width: 150,
    },
    {
      title: t("TRACK.UNISTENO"),
      dataIndex: "unisteno",
      key: "unisteno",
      width: 150,
    },
    {
      title: t("TRACK.UKUPNA_KOLICINA"),
      dataIndex: "ukupnaKolicina",
      key: "ukupnaKolicina",
      width: 150,
    },
    {
      title: t("TRACK.STANJE_NA_ZALIHAM"),
      dataIndex: "stanjeNaZalihama",
      key: "stanjeNaZalihama",
      width: 200,
    },
  ] as ColumnType<IzvestajiOPrometuProizvodnja>[];

  return (
    <Table
      name="proizvodnja"
      dataSource={proizvodnja}
      columns={columns}
      rowKey="id"
      pagination={false}
      scrollConfig={[
        ".ant-tabs-nav-wrap",
        ".ant-pagination",
        "#izvestaji-o-prometu-filters",
      ]}
    />
  );
};

export default ProizvodnjaTable;
